import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import { TitleAircraftUtilization } from "./Constant/Source";
import AircraftUtilizationEditForm from "./Forms/AircraftUtilizationEditForm";

const AircraftUtilizationEdit: FC<EditProps> = props => {
  return (
    <Edit
      title={TitleAircraftUtilization.edit}
      component="div"
      transform={(data: any) => {
        const { frCycle, frHour, frMinute, ...rest } = data;
        return rest;
      }}
      {...props}
    >
      <AircraftUtilizationEditForm {...props} />
    </Edit>
  );
};

export default AircraftUtilizationEdit;
